export const agency = {
  MASTER_LOGIN: 'accounts/authenticate', // TODO andrej 15.01.2019 Remove this once the original LOGIN URL has the API_ROOT removed
  LOGIN_AS_FOLLOWER: 'accounts/impersonate',
  MASTER_FOLLOWERS: 'accounts/all/follower',
  CREATE_FOLLOWER_ACCOUNT: 'accounts/merchants',
  UPDATE_DELETE_FOLLOWER_ACCOUNT: 'accounts/merchants/relation',
  GET_PAYMENT_METHODS: 'payments/methods',
};
